import {
  Divider,
  Flex,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import Layout from "../../containers/Layout";
import CustomButton from "../commons/CustomButton/CustomButton";
import HeadingSection from "../commons/HeadingSection/HeadingSection";
import { useTheme } from "@emotion/react";
import { Link } from "react-router-dom";

const HorizontalCardPricesInmersion = () => {
  const { colors } = useTheme();

  return (
    <Layout>
      <HeadingSection title="Pricing" sub="" />
      <Flex
        mb={12}
        flexDirection={{ base: "column", md: "row" }}
        borderWidth="1px"
        borderRadius="lg"
        overflow="hidden"
        boxShadow="2xl"
        justifyContent="space-around"
        alignItems="center"
        bg={useColorModeValue(
          colors.light.bgSecondary,
          colors.dark.bgSecondary
        )}
        borderColor={useColorModeValue(colors.light.border, colors.dark.border)}
        p="8"
      >
        <Flex direction="column" alignItems="center">
          <Text fontSize="6xl" color="orange">
            600 $
          </Text>
          <Text fontWeight="bold" mt={1}>
            7-day Immersion Program
          </Text>
        </Flex>

        <Flex my={{ base: "12", md: "0" }} direction="column">
          <VStack align="start" spacing={4}>
            <Text>📚 10 hours of group Spanish lessons</Text>
            <Divider
              borderColor={useColorModeValue(
                colors.light.border,
                colors.dark.border
              )}
              borderWidth="1px"
              height="auto"
            />
            <Text>🌘 Guided eclipse viewing with commentary</Text>
            <Divider
              borderColor={useColorModeValue(
                colors.light.border,
                colors.dark.border
              )}
              borderWidth="1px"
              height="auto"
            />
            <Text>🏞️ Cultural excursions & activities</Text>
          </VStack>
        </Flex>

        <Flex direction="column">
          <Link to="">
            <CustomButton label="Soon!" />
          </Link>
        </Flex>
      </Flex>
    </Layout>
  );
};

export default HorizontalCardPricesInmersion;
